import {toast, ToastContainer} from "react-toastify";
import TopAdminBar from "../../components/TopAdminBar";
import {Col, Container, Row} from "react-bootstrap";
import Footer from "../../components/Footer";
import React, {useState} from "react";
import {POST, request} from "../../api/ApiAdapter";
import {useHistory} from "react-router-dom";

const OrderSupplies = () => {
    const [mailInfo, setMailInfo] = useState({
        label: false,
        ribbon: false,
        message: '',
    });
    const [isPageLoading, setIsPageLoading] = useState(false);
    const history = useHistory();

    const onSendMail = async () => {
        setIsPageLoading(true);
        try {
            const result = await request("prints/send/email", POST, {
                label: mailInfo.label,
                ribbon: mailInfo.ribbon,
                message: mailInfo.message,
            });
            if (!result.error) {
                toast.success(result.message);
                setIsPageLoading(false);
            } else if (result.error.response.status === 403){
                toast.error(result.error.response.data.message);
                setIsPageLoading(false);
            } else{
                toast.error("Unauthorized");
                setIsPageLoading(false);
                history.push("/page/login");
            }
        } catch (e) {
            toast.error("Unauthorized");
            setIsPageLoading(false);
            history.push("/page/login");
        }
    };

    const handleLabelInfo = (e) => {
        setMailInfo({ ...mailInfo, label: e.target.checked});
    };

    const handleRibbonInfo = (e) => {
        setMailInfo({ ...mailInfo, ribbon: e.target.checked});
    };

    const handleMessageInfo = (e) => {
        setMailInfo({ ...mailInfo, message: e.target.value});
    };


    return(
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='colored'
            />
            <div className="bg-white h-screen">
                <TopAdminBar/>
                <div className="ml-64 top-1 mt-6 left-0 flex items-center overflow-auto">
                    <Container className="mr-10 mt-2 ">
                        <Container className="mr-10 mt-6 ">
                            <Row>
                                <Col xs={4}></Col>
                                <Col xs={4}>
                                    <div><b className="text-lg mt-20">Printer Materials Request</b></div>
                                    <div className="mt-8">
                                        <div className="text-xs">
                                            <div className="mt-4">
                                                <div className="flex">
                                                    <label
                                                        htmlFor="label"
                                                        className=" block text-sm pb-1 font-medium text-gray-700"
                                                    >
                                                        <div>Label</div>
                                                    </label>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleLabelInfo(e)}
                                                        className="ml-7 sm:text-sm rounded-md bg-gray-100"
                                                    />
                                                </div>
                                                <div className="flex mt-3">
                                                    <label
                                                        htmlFor="ribbon"
                                                        className="block text-sm  font-medium text-gray-700"
                                                    >
                                                        <div>Ribbon</div>
                                                    </label>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleRibbonInfo(e)}
                                                        className="ml-4 sm:text-sm rounded-md bg-gray-100"
                                                    />
                                                </div>
                                            </div>
                                            <div className="mt-3">
                                                <label
                                                    htmlFor="message"
                                                    className="block text-sm font-medium text-gray-700"
                                                >
                                                    <div>Message</div>
                                                </label>
                                                <textarea
                                                    onChange={(e) => handleMessageInfo(e)}
                                                    className='border-2 p-2 pt-3 bg-[#E5E7EB] rounded-md shadow-sm md:w-96 mt-1'
                                                />
                                            </div>
                                        </div>
                                        <div className="p-4 flex justify-end rounded-b-md">
                                            <div className="space-x-4">
                                                <button
                                                    onClick={() => onSendMail()}
                                                    disabled={mailInfo.ribbon === false && mailInfo.label === false && mailInfo.message === ''}
                                                    type="button"
                                                    style={{
                                                        backgroundColor:
                                                            (mailInfo.ribbon === false && mailInfo.label === false && mailInfo.message === '') ? 'rgb(107, 114, 128)' : null,
                                                    }}
                                                    className="bg-blue-500 gray text-white mr-2 font-poppins rounded-lg h-10 shadow-md w-32 hover:bg-blue-600"
                                                >
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={4}></Col>
                            </Row>
                        </Container>
                    </Container>
                </div>
                <Footer />
            </div>
            {isPageLoading && (
                <div className="absolute top-0 bottom-0 left-0 right-0 bg-black z-50 opacity-70 flex justify-center items-center">
                    <svg
                        role="status"
                        className="inline w-10 h-10 ml-48 text-gray-400 dark:text-gray-400 opacity-100 animate-spin fill-[#005FFF]"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="gray"
                        />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="blue"
                        />
                    </svg>
                </div>
            )}
        </>
    );
}
export default OrderSupplies;